// extracted by mini-css-extract-plugin
export var cell = "_6b-4";
export var headerCell = "_6b-2";
export var rowHeader = "_6b-3";
export var table = "_6b-1";
export var tableContainer = "_6b-0";